/** Shared by the scene importer and both visual-media file pickers. */
export const VISUAL_MEDIA_ACCEPT = ".png,.jpg,.jpeg,.webp,.mp4,.m4v,.webm";

/**
 * Returns the MIME used for a supported visual video file. An M4V is normally
 * an ISO Base Media File Format container, so browser-compatible M4V playback
 * is handled as video/mp4 when the operating system does not supply a MIME.
 */
export function visualVideoMime(name: string, mime: string | undefined) {
  const extension = name.split(".").pop()?.toLowerCase();
  const normalizedMime = mime?.trim().toLowerCase() ?? "";
  if (extension === "webm") return normalizedMime.startsWith("video/") ? normalizedMime : undefined;
  if (extension !== "mp4" && extension !== "m4v") return undefined;
  if (normalizedMime.startsWith("video/")) return normalizedMime;
  if (!normalizedMime || normalizedMime === "application/octet-stream") return "video/mp4";
  return undefined;
}
